import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import {
  useUpdateCart,
  UpdateCartData,
  UpdateCartProps,
} from "src/hooks/useUpdateCart";
import { useSession } from "next-auth/client";
import { requestSource } from "src/hooks/useSegment";
import { useCart } from "./useCart";

interface AddDiscountCodeToCartHook {
  data?: UpdateCartData;
  loading: boolean;
  error?: ApolloError;
  addDiscountCodeToCart: (discountCode: string) => void;
}

const useAddDiscountCodeToCart = ({
  refetchQueries = [],
  onCompleted,
  onError,
}: UpdateCartProps): AddDiscountCodeToCartHook => {
  const { data: cartData } = useCart();
  const [session] = useSession();
  const customerEmail =
    session?.user.email || cartData?.cart?.shippingAddress?.email || undefined;

  const { updateCart, loading, error } = useUpdateCart({
    refetchQueries,
    onCompleted,
    onError,
  });

  const addDiscountCodeToCart = useCallback(
    (discountCode: string) =>
      updateCart([
        {
          setCustomField: {
            name: "device_type",
            value: `\"${requestSource.request_source}\"`,
          },
        },
        {
          setCustomerEmail: {
            email: customerEmail,
          },
        },
        {
          addDiscountCode: {
            code: discountCode,
            validateDuplicates: true,
          },
        },
      ]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateCart]
  );

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  return { addDiscountCodeToCart, loading, error };
};

export { useAddDiscountCodeToCart };
